import * as React from 'react';

import {Content, RaiseLabelStyled} from './Raiselabel.styles';
import {IRaiseLabelProps, IRaiseLabelContentProps} from './RaiseLabel.types';

const RaiseLabel = ({
  marginLeft,
  marginRight,
  marginTop,
  marginBottom,
  margin,
  children,
  labelMsg,
  labelTop,
  name,
  required,
}: IRaiseLabelProps & IRaiseLabelContentProps) =>
  labelTop ? (
    <Content
      isRequired={required}
      margin={margin}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
      marginBottom={marginBottom}>
      <RaiseLabelStyled htmlFor={name}>
        {labelMsg}
        {children}
      </RaiseLabelStyled>
    </Content>
  ) : (
    <Content
      isRequired={required}
      margin={margin}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
      marginBottom={marginBottom}>
      <RaiseLabelStyled label={labelMsg}>{children}</RaiseLabelStyled>
    </Content>
  );

export default RaiseLabel;
